// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"365":"2366006e","551":"ce6b3c40"}[chunkId] + ".js";
};